import { useLocation, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  "/privacy": {
    title: "Privacy Policy",
    body: [
      "The 3E Business Leak Finder is operated by Tycoon Promotions / 3E Audit. This policy explains what information we collect and how we use it. It is written to be simple and easy to understand.",
      "What we collect: basic customer information such as your name, email address, business name, website or social media link, your survey answers, your payment status, and your booking status.",
      "How we use it: to process your payment, unlock the survey, generate your results, send you confirmation and results emails, provide support, and improve the service.",
      "We do not sell your customer data.",
      "Payments: your card and payment details are handled securely by Stripe. We do not store your card details directly.",
      "Email: confirmation and results emails may be sent using Resend.",
      "Contact: for any privacy, refund, or support questions, email frankmarina@3eleakfinder.com (backup: tycoonpromotions@gmail.com).",
    ],
  },
  "/terms": {
    title: "Terms of Service",
    body: [
      "These terms apply to The 3E Business Leak Finder, operated by Tycoon Promotions / 3E Audit. By purchasing or using the service, you agree to them.",
      "What this is: The 3E Business Leak Finder is a business diagnostic and strategy support tool. It helps identify where a business may be losing money, attention, customers, or consistency, based on the answers you provide.",
      "No guarantees: this tool does not guarantee revenue, sales, leads, profit, or business success. Results are based on your survey answers and are provided for informational and strategic purposes only.",
      "Your responsibility: you are responsible for your own business decisions and for implementing (or not implementing) any recommendations.",
      "Products: the $49 Leak Finder Survey + Basic Results delivers an automated basic diagnosis. The $97 30-Minute Strategy Call is a personalized live call with Frank Marina III to review your results and plan next steps. The $129 Bundle combines the $49 Audit and the discounted $97 Strategy Call (normally $146 together).",
      "Payments are processed securely through Stripe. Emails and results are delivered through Resend.",
      "Access codes: access codes are for approved users only and may expire or be revoked at any time.",
      "Contact: frankmarina@3eleakfinder.com (backup: tycoonpromotions@gmail.com) · https://3eleakfinder.com",
    ],
  },
  "/refund": {
    title: "Refund Policy",
    body: [
      "This refund policy applies to The 3E Business Leak Finder by Tycoon Promotions / 3E Audit.",
      "$49 Leak Finder Survey + Basic Results: this is a digital diagnostic product. Because access is delivered immediately after payment, it is generally non-refundable once the survey has been accessed, started, submitted, or once results have been generated.",
      "Technical issues: if you pay but cannot access the survey due to a technical problem, please email support within 7 days so we can fix your access or review the situation.",
      "$97 Strategy Call & $129 Bundle: the Strategy Call includes a personalized breakdown and a 30-minute live call; the Bundle also includes the $49 Audit. Refund requests for the call must be made before the call is scheduled or completed. The Audit portion of the Bundle is non-refundable once the survey has been accessed or results generated.",
      "Missed calls: a missed call may be rescheduled once if you contact us in advance or within a reasonable time.",
      "No guarantees: we do not guarantee any specific business revenue, sales, or marketing results.",
      "To request a refund or ask a question, email frankmarina@3eleakfinder.com (backup: tycoonpromotions@gmail.com).",
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const page = CONTENT[pathname] || { title: "Not found", body: ["This page does not exist."] };

  return (
    <div className="min-h-screen bg-brand-bone">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-brand-green hover:text-brand-goldDark text-sm font-medium">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold mt-6 text-brand-ink" data-testid="legal-title">{page.title}</h1>
        <p className="mt-3 text-sm text-brand-ink/45" data-testid="legal-updated">Last updated: June 2026</p>
        <div className="mt-8 space-y-5">
          {page.body.map((p, i) => (
            <p key={i} className="text-brand-ink/75 leading-relaxed">{p}</p>
          ))}
        </div>
        <p className="mt-12 text-sm text-brand-ink/45">
          Powered by Tycoon Promotions and 3E Audit · 3eleakfinder.com
        </p>
      </div>
    </div>
  );
}
